import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmDeactivateDialog({ open, onClose, onConfirm }: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Deactivate Account</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You will be logged out and unable to log back in until an admin reactivates your account.
          Your current season marking assignments and centre management links will be removed.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  );
}
